module.exports = __webpack_public_path__ + "img/pbl02_05.df07a609.jpg";